import { t } from 'i18next';
import CustomSVGs from '../../../ui/customSVGs/CustomSVGs';
import '../../../styles/cards/mcpStatusCard.scss';
import { linkSVG, settingSVG } from '../../../lib/allCustomSVGs';
import ToggleSwitch from '../../../ui/buttons/ToggleSwitch';
import { useState } from 'react';

interface Props {
  info: string;
  active?: string;
  color?: string;
  icon?: any;
  iconTitle?: string;
  image?: any;
  disabled?: boolean;
  hideConfigure?: boolean;
  onClick?: () => void;
  onStatusToggle?: (newStatus: boolean) => void;
  hasOAuth?: boolean;
  isToggleHidden?: boolean;
}

const MCPStatusCard = ({
  info,
  active,
  color,
  icon,
  image,
  disabled,
  hideConfigure,
  onClick,
  onStatusToggle,
  hasOAuth = false,
  isToggleHidden = false,
  iconTitle = '',
}: Props) => {
  const [isToggling, setIsToggling] = useState(false);

  const handleStatusToggle = async () => {
    if (!onStatusToggle || isToggling || disabled) return;

    try {
      setIsToggling(true);
      await onStatusToggle(active !== 'true');
    } catch (error) {
      console.error('Error toggling MCP status:', error);
    } finally {
      setIsToggling(false);
    }
  };

  return (
    <div className='mcpStatusCard'>
      {icon && (
        <div title={iconTitle} className='mcpStatusCard__icon'>
          <CustomSVGs svg={icon} />
        </div>
      )}
      <div className='mcpStatusCard__content-holder'>
        {image && (
          <div className='mcpStatusCard__image'>
            <img src={image} alt='status' />
          </div>
        )}
        <div className='mcpStatusCard__content'>
          <h2
            style={{
              color:
                color === 'green'
                  ? '#28a745'
                  : color === 'red'
                  ? '#FF4433'
                  : color === 'yellow'
                  ? '#f79640'
                  : 'var(--main-text-color)',
            }}
          >
            {info}
          </h2>

          <div className='mcpStatusCard__inner-content-holder'>
            <div className='mcpStatusCard__inner-content-holder-left'>
              {active !== undefined && (
                <>
                  <div
                    data-mcp-status={
                      active === 'true'
                        ? 'green'
                        : active === 'false'
                        ? 'yellow'
                        : 'red'
                    }
                    className='mcpStatusCard__inner-content-holder-left-tag-status'
                  >
                    <span>
                      {active === 'true'
                        ? t('Connected')
                        : active === 'false'
                        ? t('Deactivated')
                        : t('NotConnected')}
                    </span>
                  </div>
                  {!hideConfigure && (
                    <>
                      {active === 'true' || active === 'false' ? (
                        <div
                          className='mcpStatusCard__inner-content-holder-left-tag-config'
                          data-has-icon={icon ? 'true' : 'false'}
                          onClick={disabled ? undefined : onClick}
                          style={{
                            cursor: disabled
                              ? 'not-allowed'
                              : onClick
                              ? 'pointer'
                              : 'default',
                          }}
                        >
                          {icon ? (
                            <CustomSVGs svg={icon} />
                          ) : (
                            <CustomSVGs svg={settingSVG} />
                          )}
                          <span>{t('Configure')}</span>
                        </div>
                      ) : (
                        <div
                          className='mcpStatusCard__inner-content-holder-left-tag-connect'
                          onClick={disabled ? undefined : onClick}
                          style={{
                            cursor: disabled
                              ? 'not-allowed'
                              : onClick
                              ? 'pointer'
                              : 'default',
                          }}
                        >
                          {hasOAuth && <CustomSVGs svg={linkSVG} />}
                          <span>{t('Connect')}</span>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
            <div className='mcpStatusCard__inner-content-holder-right'>
              {(active === 'true' || active === 'false') && (
                <div className='mcpStatusCard__inner-content-holder-right-toggle'>
                  {!isToggleHidden && (
                    <ToggleSwitch
                      isOn={active === 'true'}
                      onClick={handleStatusToggle}
                      disabled={isToggling || disabled}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MCPStatusCard;
